/**
 * Publik bosh sahifa va yon menyu matnlari (uz / ru / en).
 * `index.tsx` bularni asosiy lug'atlarga qo'shadi; bu yerda bo'lmagan kalit
 * uchun o'zbekcha matn zaxira sifatida ko'rsatiladi.
 */
type Dict = Record<string, string>;

export const publicUz: Dict = {
  "nav.home": "Bosh sahifa",
  "nav.lease": "Ijaraga beriladigan maydonlar",
  "nav.market": "Elektron yashil olam",
  "nav.seedlings": "Ko'chat tanlash va parvarish",
  "nav.appealSend": "Murojaat yuborish",
  "nav.appealTrack": "Murojaatni kuzatish",
  "nav.soon": "Tez kunda",

  "home.lead":
    "O'rmonlar, yashil hududlar va tabiiy resurslar haqidagi ma'lumotlar, interaktiv xarita, " +
    "elektron xizmatlar hamda o'rmon mahsulotlari savdosini birlashtiruvchi milliy axborot platformasi.",
  "home.cabinet": "Kabinetga kirish",

  "quick.title": "Asosiy xizmatlar",
  "quick.lease": "Ochiq maydonlar va ijara jarayoni haqida ma'lumot.",
  "quick.services": "Ariza, ruxsatnoma va boshqa xizmatlar.",
  "quick.appeal": "Xabar, taklif yoki muammoni yuborish.",
  "quick.seedlings": "Aholi uchun amaliy qo'llanmalar.",

  "about.purpose": "Maqsad va vazifalar",
  "about.schemaCore": "Yagona ma'lumot muhiti",
  "about.schemaUsers": "Foydalanuvchilar",
  "about.audience": "Kimlar uchun?",
  "about.features": "Asosiy imkoniyatlar",
  "about.access": "Ochiq va shaxsiy xizmatlar",
  "about.accessLead": "Xizmatdan oldin kirish talab qilinadimi — shu yerda ko'rinadi.",
  "about.openTitle": "Kirishsiz ko'riladi",
  "about.oneidTitle": "OneID orqali kirish talab qilinadi",
  "about.stats": "Ochiq ko'rsatkichlar",
  "about.statsLead": "Har bir ko'rsatkich uchun hisobot davri, manba va yangilangan sana ko'rsatilgan.",
  "about.period": "Davr",
  "about.updated": "Yangilangan",
  "about.source": "Manba",
  "about.agency": "Mas'ul tashkilot",
  "about.tasks": "Asosiy vazifalari",
  "about.website": "Rasmiy sayt",
  "about.contacts": "Aloqa sahifasi",
  "about.leadership": "Rahbariyat",
  "about.structure": "Tuzilma",
  "about.leadersOfficial": "Rahbariyat haqidagi amaldagi ma'lumotlar agentlikning rasmiy saytida e'lon qilingan.",
  "about.leadersLink": "Rasmiy saytda ko'rish",
  "about.help": "Foydalanishga yordam",
  "about.internal": "Xodimlar uchun",
  "about.access.open": "Kirishsiz",
  "about.access.oneid": "OneID orqali",
  "about.access.mixed": "Ko'rish ochiq, amal — OneID",
  "about.access.staff": "Xodimlar kabineti",
  "about.open": "Ochish",

  "news.title": "Yangiliklar va ekotadbirlar",
  "news.lead": "O'rmon xo'jaligi, ekotadbirlar va platforma yangiliklari.",
  "news.all": "Barcha yangiliklar",
  "news.read": "Batafsil",
  "news.auto": "gov.uz/urmon rasmiy sahifasidan avtomatik yangilanadi.",
  "news.sample": "Namuna",
  "news.sampleNote": "Hozircha e'lon qilingan yangilik yo'q — quyida namunaviy xabarlar ko'rsatilgan.",
  "news.search": "Sarlavha yoki kalit so'z",
  "news.searchBtn": "Qidirish",
  "news.category": "Toifa",
  "news.cat.all": "Barchasi",
  "news.cat.news": "Yangiliklar",
  "news.cat.event": "Ekotadbirlar",
  "news.cat.announcement": "E'lonlar",
  "news.kind.news": "Yangilik",
  "news.kind.event": "Ekotadbir",
  "news.kind.announcement": "E'lon",
  "news.dateFrom": "Sanadan",
  "news.dateTo": "Sanagacha",
  "news.reset": "Filtrlarni tozalash",
  "news.found": "{n} ta yangilik",
  "news.empty": "Yangilik topilmadi",
  "news.emptyHint": "Qidiruv so'zini yoki filtrlarni o'zgartirib ko'ring.",
  "news.loading": "Yangiliklar yuklanmoqda…",
  "news.error": "Yangiliklarni yuklab bo'lmadi. Internet aloqasini tekshirib, qayta urinib ko'ring.",
  "news.retry": "Qayta urinish",
  "news.more": "Yana yuklash",
  "news.shown": "{shown} / {total} ko'rsatilgan",
  "news.published": "E'lon qilingan",
  "news.source": "Manba",
  "news.official": "Rasmiy manbada ko'rish",
  "news.noTranslation": "Bu xabarning o'zbekcha matni yo'q — mavjud tildagi matn ko'rsatilmoqda.",
  "news.event": "Tadbir ma'lumotlari",
  "news.eventDate": "Tadbir sanasi",
  "news.eventTime": "Vaqti",
  "news.eventPlace": "Joyi",
  "news.eventOrganizer": "Tashkilotchi",
  "news.eventParticipation": "Ishtirok tartibi",
  "news.eventOn": "Tadbir",
  "news.notFound": "Yangilik topilmadi yoki o'chirilgan.",
  "news.gallery": "Suratlar",
  "news.views": "Ko'rildi",

  "market.title": "Elektron yashil olam",
  "market.lead":
    "Ko'chat, urug' va o'rmon mahsulotlari savdosi. Mahsulotlarni ko'rish uchun tizimga kirish shart emas.",
  "market.all": "Barcha mahsulotlar",
  "market.buy": "Sotib olish",
  "market.filterAll": "Hammasi",
  "market.filterLabel": "Mahsulot turi",
  "market.seller": "Sotuvchi",
  "market.sample": "Namunaviy",
  "market.region": "Hudud",
  "market.sampleNote":
    "Katalog hozircha bo'sh yoki server bilan aloqa yo'q — namunaviy mahsulotlar ko'rsatilmoqda.",
  "market.buyHint": "«Sotib olish» bosilganda OneID orqali kirish so'raladi; tanlovingiz saqlanadi.",
  "market.empty": "Bu turdagi mahsulot hozircha yo'q.",
  "market.search": "Mahsulot nomi bo'yicha qidirish…",
  "market.perUnit": "/",

  "rating.title": "Tizimni baholang",
  "rating.lead": "Fikringiz platformani yaxshilashga yordam beradi.",
  "rating.average": "Umumiy baho",
  "rating.count": "ta baho",
  "rating.none": "Hozircha baholar yo'q",
  "rating.comment": "Fikringiz (ixtiyoriy)",
  "rating.placeholder": "Nimani yaxshilash kerak?",
  "rating.send": "Baholash",
  "rating.pick": "Yulduzchalardan birini tanlang.",
  "rating.thanks": "Bahoingiz uchun rahmat!",
  "rating.already": "Siz bugun baho bergansiz. Rahmat!",

  "footer.org": "Mas'ul tashkilot",
  "footer.orgName": "O'rmon va yashil hududlarni ko'paytirish, cho'llanishga qarshi kurashish agentligi",
  "footer.links": "Bo'limlar",
  "footer.contacts": "Aloqa",
  "footer.support": "Texnik yordam",
  "footer.supportText": "Platformadan foydalanishda muammo bo'lsa, yordam xizmatiga yozing.",
  "footer.terms": "Foydalanish shartlari",
  "footer.privacy": "Maxfiylik siyosati",
  "footer.rights": "Barcha huquqlar himoyalangan.",
  "a11y.title": "Maxsus imkoniyatlar",
  "a11y.imagesOff": "Rasmlarni o'chirish",
  "a11y.font": "Shrift o'lchami:",
  "a11y.zoom": "Masshtab:",
  "a11y.reader": "Ekran suhandoni:",
  "a11y.readerOn": "Yoqish / O'chirish",
  "a11y.male": "Erkak ovozi",
  "a11y.female": "Ayol ovozi",
  "a11y.readerHint": "Yoqilgach, matn ustiga bosing — u ovoz bilan o'qiladi.",
  "a11y.translate": "Google tarjimon:",
  "a11y.pickLang": "Tilni tanlang",
  "a11y.reset": "Asl holatga qaytarish",
  "footer.appTitle": "Mobil ilovani yuklab oling",
  "footer.appText": "Murojaat yuborish, kuzatish va ochiq xarita — telefoningizda. Bepul.",

  "soon.title": "Bu modul tez kunda ishga tushadi",
  "soon.text":
    "Bu bo'lim hozir tayyorlanmoqda. Ishga tushgach, shu yerda va asosiy menyuda to'liq ochiladi.",
  "soon.meanwhile": "Hozircha quyidagi xizmatlardan foydalanishingiz mumkin:",
};

export const publicRu: Dict = {
  "nav.home": "Главная",
  "nav.lease": "Площади в аренду",
  "nav.market": "Электронный зелёный мир",
  "nav.seedlings": "Выбор и уход за саженцами",
  "nav.appealSend": "Отправить обращение",
  "nav.appealTrack": "Отследить обращение",
  "nav.soon": "Скоро",

  "home.lead":
    "Национальная информационная платформа, объединяющая данные о лесах, зелёных зонах и " +
    "природных ресурсах, интерактивную карту, электронные услуги и торговлю лесной продукцией.",
  "home.cabinet": "Войти в кабинет",

  "quick.title": "Основные услуги",
  "quick.lease": "Сведения об открытых площадях и процессе аренды.",
  "quick.services": "Заявления, разрешения и другие услуги.",
  "quick.appeal": "Отправить сообщение, предложение или сообщить о проблеме.",
  "quick.seedlings": "Практические руководства для населения.",

  "about.purpose": "Цели и задачи",
  "about.schemaCore": "Единая информационная среда",
  "about.schemaUsers": "Пользователи",
  "about.audience": "Для кого?",
  "about.features": "Основные возможности",
  "about.access": "Открытые и персональные услуги",
  "about.accessLead": "Здесь видно, нужен ли вход перед использованием услуги.",
  "about.openTitle": "Доступно без входа",
  "about.oneidTitle": "Требуется вход через OneID",
  "about.stats": "Открытые показатели",
  "about.statsLead": "Для каждого показателя указаны отчётный период, источник и дата обновления.",
  "about.period": "Период",
  "about.updated": "Обновлено",
  "about.source": "Источник",
  "about.agency": "Ответственная организация",
  "about.tasks": "Основные задачи",
  "about.website": "Официальный сайт",
  "about.contacts": "Страница контактов",
  "about.leadership": "Руководство",
  "about.structure": "Структура",
  "about.leadersOfficial": "Актуальная информация о руководстве опубликована на официальном сайте агентства.",
  "about.leadersLink": "Открыть на официальном сайте",
  "about.help": "Помощь",
  "about.internal": "Для сотрудников",
  "about.access.open": "Без входа",
  "about.access.oneid": "Через OneID",
  "about.access.mixed": "Просмотр открыт, действия — OneID",
  "about.access.staff": "Кабинет сотрудника",
  "about.open": "Открыть",

  "news.title": "Новости и экомероприятия",
  "news.lead": "Новости лесного хозяйства, экомероприятий и платформы.",
  "news.all": "Все новости",
  "news.read": "Подробнее",
  "news.auto": "Обновляется автоматически с официальной страницы gov.uz/urmon.",
  "news.sample": "Пример",
  "news.sampleNote": "Опубликованных новостей пока нет — ниже показаны примеры.",
  "news.search": "Заголовок или ключевое слово",
  "news.searchBtn": "Найти",
  "news.category": "Рубрика",
  "news.cat.all": "Все",
  "news.cat.news": "Новости",
  "news.cat.event": "Экомероприятия",
  "news.cat.announcement": "Объявления",
  "news.kind.news": "Новость",
  "news.kind.event": "Экомероприятие",
  "news.kind.announcement": "Объявление",
  "news.dateFrom": "С даты",
  "news.dateTo": "По дату",
  "news.reset": "Сбросить фильтры",
  "news.found": "Найдено: {n}",
  "news.empty": "Новости не найдены",
  "news.emptyHint": "Измените запрос или фильтры.",
  "news.loading": "Загрузка новостей…",
  "news.error": "Не удалось загрузить новости. Проверьте подключение и попробуйте снова.",
  "news.retry": "Повторить",
  "news.more": "Показать ещё",
  "news.shown": "Показано {shown} из {total}",
  "news.published": "Опубликовано",
  "news.source": "Источник",
  "news.official": "Открыть на официальном сайте",
  "news.noTranslation": "Перевода на русский язык нет — показан текст на доступном языке.",
  "news.event": "О мероприятии",
  "news.eventDate": "Дата мероприятия",
  "news.eventTime": "Время",
  "news.eventPlace": "Место",
  "news.eventOrganizer": "Организатор",
  "news.eventParticipation": "Порядок участия",
  "news.eventOn": "Мероприятие",
  "news.notFound": "Новость не найдена или удалена.",
  "news.gallery": "Фотографии",
  "news.views": "Просмотры",

  "market.title": "Электронный зелёный мир",
  "market.lead":
    "Торговля саженцами, семенами и лесной продукцией. Для просмотра товаров входить в систему не нужно.",
  "market.all": "Все товары",
  "market.buy": "Купить",
  "market.filterAll": "Все",
  "market.filterLabel": "Тип товара",
  "market.seller": "Продавец",
  "market.sample": "Пример",
  "market.region": "Регион",
  "market.sampleNote": "Каталог пока пуст или нет связи с сервером — показаны примерные товары.",
  "market.buyHint": "При нажатии «Купить» потребуется вход через OneID; ваш выбор сохранится.",
  "market.empty": "Товаров этого типа пока нет.",
  "market.search": "Поиск по названию товара…",

  "rating.title": "Оцените систему",
  "rating.lead": "Ваше мнение помогает улучшать платформу.",
  "rating.average": "Общая оценка",
  "rating.count": "оценок",
  "rating.none": "Оценок пока нет",
  "rating.comment": "Ваш отзыв (необязательно)",
  "rating.placeholder": "Что нужно улучшить?",
  "rating.send": "Оценить",
  "rating.pick": "Выберите количество звёзд.",
  "rating.thanks": "Спасибо за вашу оценку!",
  "rating.already": "Сегодня вы уже оценивали. Спасибо!",

  "footer.org": "Ответственная организация",
  "footer.orgName": "Агентство по увеличению лесов и зелёных зон, борьбе с опустыниванием",
  "footer.links": "Разделы",
  "footer.contacts": "Контакты",
  "footer.support": "Техническая поддержка",
  "footer.supportText": "Если возникли проблемы с платформой, напишите в службу поддержки.",
  "footer.terms": "Условия использования",
  "footer.privacy": "Политика конфиденциальности",
  "footer.rights": "Все права защищены.",
  "a11y.title": "Специальные возможности",
  "a11y.imagesOff": "Отключить изображения",
  "a11y.font": "Размер шрифта:",
  "a11y.zoom": "Масштаб:",
  "a11y.reader": "Экранный диктор:",
  "a11y.readerOn": "Включить / выключить",
  "a11y.male": "Мужской голос",
  "a11y.female": "Женский голос",
  "a11y.readerHint": "После включения нажмите на текст — он будет озвучен.",
  "a11y.translate": "Google Переводчик:",
  "a11y.pickLang": "Выберите язык",
  "a11y.reset": "Сбросить настройки",
  "footer.appTitle": "Скачайте мобильное приложение",
  "footer.appText": "Отправка и отслеживание обращений, открытая карта — в вашем телефоне. Бесплатно.",

  "soon.title": "Этот модуль скоро заработает",
  "soon.text":
    "Раздел сейчас готовится. После запуска он полностью откроется здесь и в основном меню.",
  "soon.meanwhile": "Пока можно воспользоваться следующими услугами:",
};

export const publicEn: Dict = {
  "nav.home": "Home",
  "nav.lease": "Land available for lease",
  "nav.market": "E-Green World",
  "nav.seedlings": "Seedling choice & care",
  "nav.appealSend": "Submit a report",
  "nav.appealTrack": "Track a report",
  "nav.soon": "Coming soon",

  "home.lead":
    "A national information platform that brings together data on forests, green areas and " +
    "natural resources, an interactive map, e-services and trade in forest products.",
  "home.cabinet": "Sign in to cabinet",

  "quick.title": "Main services",
  "quick.lease": "Information on open plots and the leasing process.",
  "quick.services": "Applications, permits and other services.",
  "quick.appeal": "Send a message, suggestion or report a problem.",
  "quick.seedlings": "Practical guides for the public.",

  "about.purpose": "Purpose and objectives",
  "about.schemaCore": "Single data environment",
  "about.schemaUsers": "Users",
  "about.audience": "Who is it for?",
  "about.features": "Key features",
  "about.access": "Open and personal services",
  "about.accessLead": "See whether a service requires signing in before you start.",
  "about.openTitle": "Available without signing in",
  "about.oneidTitle": "Requires signing in with OneID",
  "about.stats": "Open indicators",
  "about.statsLead": "Each indicator shows its reporting period, source and update date.",
  "about.period": "Period",
  "about.updated": "Updated",
  "about.source": "Source",
  "about.agency": "Responsible organisation",
  "about.tasks": "Main functions",
  "about.website": "Official website",
  "about.contacts": "Contacts page",
  "about.leadership": "Leadership",
  "about.structure": "Structure",
  "about.leadersOfficial": "Current information about the leadership is published on the agency's official website.",
  "about.leadersLink": "View on the official website",
  "about.help": "Help",
  "about.internal": "For staff",
  "about.access.open": "No sign-in",
  "about.access.oneid": "Via OneID",
  "about.access.mixed": "View open, actions via OneID",
  "about.access.staff": "Staff workspace",
  "about.open": "Open",

  "news.title": "News and eco-events",
  "news.lead": "Forestry, eco-events and platform news.",
  "news.all": "All news",
  "news.read": "Read more",
  "news.auto": "Updated automatically from the official gov.uz/urmon page.",
  "news.sample": "Sample",
  "news.sampleNote": "No news has been published yet — sample items are shown below.",
  "news.search": "Title or keyword",
  "news.searchBtn": "Search",
  "news.category": "Category",
  "news.cat.all": "All",
  "news.cat.news": "News",
  "news.cat.event": "Eco-events",
  "news.cat.announcement": "Announcements",
  "news.kind.news": "News",
  "news.kind.event": "Eco-event",
  "news.kind.announcement": "Announcement",
  "news.dateFrom": "From",
  "news.dateTo": "To",
  "news.reset": "Reset filters",
  "news.found": "{n} found",
  "news.empty": "No news found",
  "news.emptyHint": "Try another keyword or change the filters.",
  "news.loading": "Loading news…",
  "news.error": "Could not load news. Check your connection and try again.",
  "news.retry": "Try again",
  "news.more": "Load more",
  "news.shown": "Showing {shown} of {total}",
  "news.published": "Published",
  "news.source": "Source",
  "news.official": "View on the official site",
  "news.noTranslation": "This item is not available in English — the text is shown in the original language.",
  "news.event": "Event details",
  "news.eventDate": "Event date",
  "news.eventTime": "Time",
  "news.eventPlace": "Venue",
  "news.eventOrganizer": "Organizer",
  "news.eventParticipation": "How to take part",
  "news.eventOn": "Event",
  "news.notFound": "The news item was not found or has been removed.",
  "news.gallery": "Photos",
  "news.views": "Views",

  "market.title": "E-Green World",
  "market.lead":
    "Trade in seedlings, seeds and forest products. No sign-in is needed to browse the goods.",
  "market.all": "All products",
  "market.buy": "Buy",
  "market.filterAll": "All",
  "market.filterLabel": "Product type",
  "market.seller": "Seller",
  "market.sample": "Sample",
  "market.region": "Region",
  "market.sampleNote": "The catalogue is empty or the server is unreachable — sample products are shown.",
  "market.buyHint": "Pressing “Buy” asks you to sign in via OneID; your choice is kept.",
  "market.empty": "No products of this type yet.",
  "market.search": "Search by product name…",

  "rating.title": "Rate the system",
  "rating.lead": "Your feedback helps us improve the platform.",
  "rating.average": "Overall rating",
  "rating.count": "ratings",
  "rating.none": "No ratings yet",
  "rating.comment": "Your feedback (optional)",
  "rating.placeholder": "What should be improved?",
  "rating.send": "Submit",
  "rating.pick": "Pick a star rating.",
  "rating.thanks": "Thank you for your rating!",
  "rating.already": "You have already rated today. Thank you!",

  "footer.org": "Responsible organisation",
  "footer.orgName": "Agency for the Expansion of Forests and Green Areas and Combating Desertification",
  "footer.links": "Sections",
  "footer.contacts": "Contacts",
  "footer.support": "Technical support",
  "footer.supportText": "If you have trouble using the platform, write to the support service.",
  "footer.terms": "Terms of use",
  "footer.privacy": "Privacy policy",
  "footer.rights": "All rights reserved.",
  "a11y.title": "Accessibility",
  "a11y.imagesOff": "Turn images off",
  "a11y.font": "Font size:",
  "a11y.zoom": "Zoom:",
  "a11y.reader": "Screen reader:",
  "a11y.readerOn": "On / Off",
  "a11y.male": "Male voice",
  "a11y.female": "Female voice",
  "a11y.readerHint": "Once on, click any text to hear it read aloud.",
  "a11y.translate": "Google Translate:",
  "a11y.pickLang": "Choose a language",
  "a11y.reset": "Reset to defaults",
  "footer.appTitle": "Download the mobile app",
  "footer.appText": "Send and track reports, open map — on your phone. Free.",

  "soon.title": "This module launches soon",
  "soon.text":
    "This section is being prepared. Once launched, it will open here and in the main menu.",
  "soon.meanwhile": "In the meantime you can use these services:",
};
